// extracted by mini-css-extract-plugin
module.exports = {"loading1":"Loader_loading1__lpzEo","loader":"Loader_loader__tnucl"};